import React from 'react';
import { weddingData } from '../data';

export const FooterSection = () => {
  return (
    <footer className="py-16 md:py-24 px-6 bg-white border-t border-stone-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center space-y-8">
          {/* Hashtag */}
          <h3
            className="text-4xl md:text-5xl text-stone-900"
            style={{ fontFamily: 'Gabriola, "Cormorant Garamond", serif' }}
          >
            {weddingData.couple.hashtag}
          </h3>

          {/* Family */}
          <p className="text-stone-400 text-sm tracking-widest">
            {weddingData.couple.family}
          </p>

          {/* Decorative Line */}
          <div className="flex items-center justify-center pt-8">
            <div className="h-px w-32 bg-gradient-to-r from-transparent via-stone-200 to-transparent"></div>
          </div>

          {/* Copyright */}
          <p className="text-stone-400 text-xs font-light">
            © {new Date().getFullYear()} All rights reserved
          </p>
        </div>
      </div>
    </footer>
  );
};
